<template>
  <b-container>
    <h1 class="text-center">All About Testing</h1>
    <hr />
    <h2>At Commonwealth Moisture &amp; Mold Specialists, we test for a variety of substances that can be found in your home or business:</h2>
    <p>Mold samples are collected as needed to confirm or deny the hypothesis of fungal ecology. We use a variety of collection devices including swab, bulk, Allergenco D Posi-Track™ spore traps, and Auger plates. The type of collection will depend on the results needed. Samples can be cultured to determine the species or just counted to determine the fungal load. All samples are analyzed by qualified laboratories to eliminate any conflict of interest.</p>
    <br />
    <b-row>
      <b-col sm="4">
        <h1>Mold</h1>
        <em>Testing methods: Swab</em>
      </b-col>
      <b-col sm="8">
        <p>
          Molds, such as: Cladosporium, Penicillium, and Aspergillus, are commonly found indoors and can be harmful to you and your family.
          <br />Read more at
          <a href="https://www.cdc.gov/mold/faqs.htm" target="_blank">cdc.gov</a>.
        </p>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col sm="4">
        <h1>Fungal Spores</h1>
        <em>Testing methods: Air Cassettes</em>
      </b-col>
      <b-col sm="8">
        <p>
          A common fungus called Aspergillus can cause a fungal infection in people with weakened immune systems and lung diseases known as Aspergillosis. This can cause: Stuffiness, Runny nose, Headache, Wheezing, Shortness of breath, and Cough.
          <br />Read more at
          <a
            href="https://www.cdc.gov/fungal/diseases/aspergillosis/index.html"
            target="_blank"
          >cdc.gov</a>.
        </p>
      </b-col>
    </b-row>
    <h2 id="testing-header">At Commonwealth Moisture &amp; Mold Specialists, we can test for:</h2>
    <br>
    <b-card-group deck>
      <testing-card v-for="(test, index) in testing" :key="index" :test="test"/>
    </b-card-group>
  </b-container>
</template>

<script>
import TestingCard from '@/components/TestingCard.vue';
import testing from '../testing';
export default {
  name: "Testing",
  components: {
    TestingCard
  },
  data() {
    return {
      testing
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1.5em;
}
#testing-header {
  text-align: center;
}
#testing-list div p {
  text-align: center;
}
</style>